import { render, staticRenderFns } from "./WidgetPalette.vue?vue&type=template&id=8536b3fe&scoped=true"
import script from "./WidgetPalette.vue?vue&type=script&lang=js"
export * from "./WidgetPalette.vue?vue&type=script&lang=js"
import style0 from "./WidgetPalette.vue?vue&type=style&index=0&id=8536b3fe&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8536b3fe",
  null
  
)

export default component.exports